import React, { Component } from "react"
import { Link } from "gatsby"
import "./index.css"

class MegaMenu extends Component {
  render() {
    return (
      <section id="mega-menu-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-2 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head">SHOWS</li>
                <li className="font-weight-bold mega-submenu-head mb-3">
                  VARIETÉ SHOWS
                </li>
                <li>
                  <Link to="/">aktuelle Shows</Link>
                </li>
                <li>
                  <Link to="/">Zauber Zauber ab XX</Link>
                </li>
                <li>
                  <Link to="/">20 20 ab Februar</Link>
                </li>

                <li className="font-weight-bold mega-submenu-head">
                  Weitere SHOWS
                </li>

                <li>
                  <Link to="/spotlight">SPOTLIGHTS</Link>
                </li>
                <li>
                  <Link to="/">Auf der Couch</Link>
                </li>
                <li>
                  <Link to="/">Zimt & Zauber</Link>
                </li>
                <li>
                  <Link to="/">DINNERSHOWS</Link>
                </li>
                <li>
                  <Link to="/">On Tour</Link>
                </li>

                <li className="font-weight-bold mega-submenu-head">SPECIALS</li>
                <li>
                  <Link to="/">Ausstellungen</Link>
                </li>

                <li className="font-weight-bold mega-submenu-head">
                  <Link to="/">ARCHIV</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-1 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  SPIELPLAN
                </li>
                <li>
                  <Link to="/">Spielplan</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-2 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  GASTRONOMIE
                </li>
                <li>
                  <Link to="/">SHOW & DINE</Link>
                </li>
                <li>
                  <Link to="/">SHOW & WINE</Link>
                </li>
                <li>
                  <Link to="/">Restaurant</Link>
                </li>
                <li>
                  <Link to="/">Le Bistro</Link>
                </li>
                <li>
                  <Link to="/">Unsere Karte</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-2 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  EVENTLOCATION
                </li>
                <li>
                  <Link to="/">Gala & Produkt- präsentationen</Link>
                </li>
                <li>
                  <Link to="/">Firmen & Gruppen</Link>
                </li>
                <li>
                  <Link to="/">Besondere Anlässe</Link>
                </li>
                <li>
                  <Link to="/">Foto & Video Location</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-2 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  SERVICE
                </li>
                <li>
                  <Link to="/">Theaterkasse</Link>
                </li>
                <li>
                  <Link to="/">Gutscheine</Link>
                </li>
                <li>
                  <Link to="/">VIP Gutscheine</Link>
                </li>
                <li>
                  <Link to="/">Anfahrt & Kontakt</Link>
                </li>
                <li>
                  <Link to="/">Valet Parking</Link>
                </li>
                <li>
                  <Link to="/">Fotograf & Close-up</Link>
                </li>
                <li>
                  <Link to="/">Künstlervermittlung</Link>
                </li>
                <li>
                  <Link to="/">NEWSLETTER</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-1 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  PRESSE
                </li>
                <li>
                  <Link to="/">Presse</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-1 mega-submenu p-0">
              <ul className="mega-submenu">
                <li className="font-weight-bold mega-submenu-head mb-3">
                  DAS HAUS
                </li>
                <li>
                  <Link to="/">Portrait</Link>
                </li>
                <li>
                  <Link to="/">Chronik</Link>
                </li>
                <li>
                  <Link to="/">Team</Link>
                </li>
                <li>
                  <Link to="/">Jobs</Link>
                </li>
                <li>
                  <Link to="/">Unsere Partner</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-1 mega-submenu p-0">
              <i
                className="fa fa-close float-right mega-menu-close"
                {...this.props}
              ></i>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default MegaMenu
